import React from 'react';

import Button from 'components/shared/Button';
import Icon from 'components/shared/Icon';
import Plus from 'components/shared/Icon/icons/Plus';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

import ActionsMenu from '../../ActionsMenu';
import { useAddEventMenuActions, useChronologicalMode } from '../functions';
import { Timeline } from '../Timeline';
import Calendar from './Calendar';
import Header from './Header';
import s from './index.module.css';
import MobileWarningWrapper from './MobileWarningWrapper';

function EventCalendar() {
  const { nextDayToCreate } = useChronologicalMode();
  const { isTabletOrMobile } = useMediaBreakpoints();
  const addEventMenuActions = useAddEventMenuActions(nextDayToCreate);
  /**
   * We need these refs for useOutsideClick in Calendar to prevent reset of selected events
   */
  const headerActionsBtnRef = React.useRef<HTMLDivElement>(null);
  const headerActionsMenuRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    // FIXME | How to disable scroll temporay?
    const scrollableContainer = document.getElementById('formSections');
    if (scrollableContainer) scrollableContainer.setAttribute('style', 'overflow-y: hidden;');
  }, []);

  return (
    <MobileWarningWrapper>
      <div>
        <Header actionsRefs={{ btnRef: headerActionsBtnRef, menuRef: headerActionsMenuRef }} />

        <div className={s['content-container']}>
          <div className={s['timeline-container']}>
            <Timeline />

            <ActionsMenu actions={addEventMenuActions}>
              <Button type="default" className={s.addEvent}>
                <Icon component={() => <Plus fill="#3f3c43" />} className={s.addEventIcon} />
                Add Event
              </Button>
            </ActionsMenu>
          </div>

          {!isTabletOrMobile && (
            <div className={s['calendar-container']}>
              <Calendar actionsRefs={{ btnRef: headerActionsBtnRef, menuRef: headerActionsMenuRef }} />
            </div>
          )}
        </div>
      </div>
    </MobileWarningWrapper>
  );
}

export default EventCalendar;
